import React, { Component } from 'react';
import PropTypes from 'prop-types';
import handleKeyPress from '../../common/handleKeyPress';
import * as Styled from './styles';

export default class ButtonGroup extends Component {
    state = {
        selected: 0,
    };

    componentDidMount = () => {
        const { selected } = this.props;
        if (selected) {
            this.setState({ selected });
        }
    };

    componentDidUpdate(prevProps) {
        const { selected } = prevProps;
        const { selected: newSelected } = this.props;

        // when the user clicks on another element that uses button group, we need to load the selected again in order to refresh the UI
        if (selected !== newSelected) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ selected: newSelected });
        }
    }

    onButtonClick = (event, index, onClick) => {
        const { selected } = this.state;

        if (selected === index) {
            return;
        }
        this.setState({ selected: index });

        onClick(event.currentTarget.innerText.toLowerCase());
    };

    render() {
        const { onClick, options, width, marginBottom } = this.props;
        const { selected } = this.state;

        return (
            <Styled.ButtonGroupDiv marginBottom={marginBottom} width={width}>
                {options.map((option, index) => (
                    <Styled.Button
                        selected={selected}
                        aria-pressed={selected === index}
                        width={180 / options.length}
                        last={options.length - 1}
                        ind={index}
                        type="button"
                        role="button"
                        aria-label={`Use ${option} option`}
                        key={`${option}-key`}
                        data-test-id={`${option}-key`}
                        onClick={(e) => this.onButtonClick(e, index, onClick)}
                        onKeyDown={(e) => handleKeyPress(e, () => this.onButtonClick(e, index, onClick))}
                    >
                        <span style={{ fontSize: 12, fontWeight: 600 }}>{option}</span>
                    </Styled.Button>
                ))}
            </Styled.ButtonGroupDiv>
        );
    }
}

ButtonGroup.propTypes = {
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClick: PropTypes.func.isRequired,
    width: PropTypes.number,
    marginBottom: PropTypes.number,
};

ButtonGroup.defaultProps = {
    width: 180,
    marginBottom: 10,
};
